import React from "react";
import { AccessibleLinkProps } from "./AccessibleLinks.types";
import * as Styles from "./AccessibleLinks.styles";
import SkipToMainContent from "../../structure/SkipToMainContent/SkipToMainContent";

const AccessibleLink: React.FC<AccessibleLinkProps> = ({
    AccessibleLinksArray = null,
    includeSkipToMainContent = false,
    listItem = true
}) => 
{
    const ListItemWrapper = ({ children }: { children: React.ReactNode }) => {
        return listItem ? <Styles.AccessibleListItem>{children}</Styles.AccessibleListItem> : <>{children}</>;
    };

    const ListWrapper = ({ children }: { children: React.ReactNode }) => {
        return listItem ? <Styles.AccessibleList>{children}</Styles.AccessibleList> : <>{children}</>;
    };

    return (
        <ListWrapper>
            {includeSkipToMainContent && (
                <ListItemWrapper>
                    <SkipToMainContent />
                </ListItemWrapper>
            )}
            {AccessibleLinksArray && AccessibleLinksArray.map((link, i) => (
                <ListItemWrapper key={'accessible-link-li-' + i}>
                    <Styles.AccessibleLinks
                        key={'accessible-link-' + i}
                        href={link.url}
                    >
                        {link.title}
                    </Styles.AccessibleLinks>
                </ListItemWrapper>
            ))}
        </ListWrapper>
    );
}
        
export default AccessibleLink;
        
        
